<div class="dropdown-question">
  @if (isEditing()) {
    <div class="question-config">
      <label class="config-label">
        @if (getQuestionTypeIcon(); as iconInfo) {
          <span class="question-type-icon-wrapper">
            @if (iconInfo.iconType === 'prime') {
              <i [class]="'pi ' + iconInfo.icon" class="question-type-icon"></i>
            }
            @if (iconInfo.iconType === 'material') {
              <span class="material-symbols-outlined question-type-icon">{{ iconInfo.icon }}</span>
            }
          </span>
        }
        Question Text
      </label>
      <input
        #labelInput
        type="text"
        class="config-input label-input"
        [value]="question().labelText"
        (input)="onLabelChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter your question label here...">

      <label class="config-label">Additional Info</label>
      <input
        type="text"
        class="config-input"
        [value]="question().additionalInfo ?? ''"
        (input)="onAdditionalInfoChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter additional information">

      <label class="config-label">Helper Text</label>
      <input
        type="text"
        class="config-input"
        [value]="question().helperText ?? ''"
        (input)="onHelperTextChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter helper text">

      <label class="checkbox-label">
        <input
          type="checkbox"
          class="config-checkbox"
          [checked]="question().isSearchable ?? false"
          (change)="onSearchableToggle($any($event.target).checked)"
          [disabled]="disabled()">
        <span>Enable search in dropdown</span>
      </label>

      <label class="checkbox-label dynamic-options-toggle">
        <input
          type="checkbox"
          class="config-checkbox"
          [checked]="question().hasDynamicOptions ?? false"
          (change)="onDynamicOptionsToggle($any($event.target).checked)"
          [disabled]="disabled()">
        <span>Dynamic Options</span>
        <span class="material-symbols-outlined dynamic-icon">dynamic_feed</span>
      </label>

      <!-- Static Options Configuration -->
      @if (!question().hasDynamicOptions) {
        <label class="config-label">Options</label>
        <div class="options-list">
          @for (option of options; track $index; let i = $index) {
            <div class="option-item">
              <input
                #optionInput
                type="text"
                class="config-input option-input"
                [value]="option.text"
                (input)="onOptionChange(i, $any($event.target).value)"
                (blur)="onOptionBlur()"
                [disabled]="disabled()"
                [placeholder]="'Option ' + (i + 1)">
              <label class="custom-option-checkbox-label">
                <input
                  type="checkbox"
                  class="config-checkbox"
                  [checked]="option.isCustomOption"
                  (change)="onCustomOptionToggle(i, $any($event.target).checked)"
                  [disabled]="disabled()">
                <span>Custom</span>
              </label>
              <button
                type="button"
                class="remove-option-button"
                (click)="removeOption(i)"
                [disabled]="disabled()"
                aria-label="Remove option">
                <span class="material-symbols-outlined">delete_forever</span>
              </button>
            </div>
          }
          <button
            type="button"
            class="add-option-button"
            (click)="addOption()"
            [disabled]="disabled()"
            aria-label="Add option">
            <i class="pi pi-plus"></i>
            <span>Add Option</span>
          </button>
        </div>
      }

      <!-- Dynamic Options Configuration -->
      @if (question().hasDynamicOptions) {
        <div class="dynamic-options-section">
          <label class="section-header">
            <span class="material-symbols-outlined section-icon">dynamic_feed</span>
            Option Generation Configuration
          </label>

          <div class="config-field">
            <label class="config-label">Source Container</label>
            <input
              type="text"
              class="config-input"
              [value]="question().sourceContainer ?? ''"
              (input)="onSourceContainerChange($any($event.target).value)"
              [disabled]="disabled()"
              placeholder="Enter source container path...">
          </div>

          <div class="config-field">
            <label class="config-label">Text Property</label>
            <input
              type="text"
              class="config-input"
              [value]="question().textProperty ?? ''"
              (input)="onTextPropertyChange($any($event.target).value)"
              [disabled]="disabled()"
              placeholder="Enter text property path...">
          </div>

          <div class="config-field">
            <label class="config-label">Custom Option ID</label>
            <input
              type="text"
              class="config-input"
              [value]="question().customOptionId ?? ''"
              (input)="onCustomOptionIdChange($any($event.target).value)"
              [disabled]="disabled()"
              placeholder="Enter custom option ID field...">
          </div>

          <div class="config-field">
            <label class="config-label">Custom Option Text</label>
            <input
              type="text"
              class="config-input"
              [value]="question().customOptionText ?? ''"
              (input)="onCustomOptionTextChange($any($event.target).value)"
              [disabled]="disabled()"
              placeholder="Enter custom option text field...">
          </div>
        </div>
      }

      <div class="required-toggle-row">
        <label class="config-label">
          <span class="required-asterisk">*</span>
          Required
        </label>
        <label class="required-toggle-switch">
          <input
            type="checkbox"
            [checked]="question().isRequired"
            (change)="onRequiredToggle()"
            [disabled]="disabled()">
          <span class="toggle-slider"></span>
        </label>
      </div>
    </div>
  } @else {
    <div class="question-preview">
      <div class="question-label-wrapper">
        <label class="question-label">
          <span [innerHTML]="sanitizeHtml(question().labelText || 'Dropdown')"></span>
          @if (question().isRequired) {
            <span class="required-indicator">*</span>
          }
        </label>
        @if (question().additionalInfo) {
          <span class="additional-info" [innerHTML]="sanitizeHtml(question().additionalInfo)"></span>
        }
      </div>
      <div class="dropdown-wrapper">
        <!-- Show actual dropdown if options are populated (even for dynamic dropdowns in view mode) -->
        @if (hasPopulatedOptions()) {
          <!-- Searchable Dropdown -->
          @if (question().isSearchable) {
            <div class="searchable-dropdown" #dropdownContainer>
              <div #dropdownTrigger class="dropdown-trigger" (click)="toggleDropdown()" [class.open]="isDropdownOpen" [class.readonly]="disabled()">
                <span class="dropdown-selected-text">
                  {{ selectedOptionIndex !== null ? getOptionText(options[selectedOptionIndex]) : 'Select an option' }}
                </span>
                <i class="pi pi-chevron-down dropdown-arrow" [class.rotated]="isDropdownOpen"></i>
              </div>
              @if (isDropdownOpen) {
                <div class="dropdown-menu" [ngStyle]="dropdownMenuStyle">
                  @if (question().isSearchable) {
                    <div class="dropdown-search">
                      <input
                        type="text"
                        class="search-input"
                        [value]="searchTerm"
                        (input)="onSearchInputChange($any($event.target).value)"
                        (click)="$event.stopPropagation()"
                        placeholder="Search options..."
                        autofocus>
                      <i class="pi pi-search search-icon"></i>
                    </div>
                  }
                  <div class="dropdown-options">
                    @if (filteredOptions.length === 0) {
                      <div class="dropdown-no-results">
                        No options found
                      </div>
                    }
                    @for (option of filteredOptions; track $index) {
                      <div
                        class="dropdown-option"
                        [class.selected]="selectedOptionIndex !== null && getOptionText(option) === getOptionText(options[selectedOptionIndex])"
                        (click)="selectOption(option)">
                        {{ getOptionText(option) }}
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }

          <!-- Standard Dropdown -->
          @if (!question().isSearchable) {
            <select
              class="question-select"
              [class.readonly]="disabled()"
              (change)="onSelectChange($any($event.target).value)">
              <option value="" disabled selected>Select an option</option>
              @for (option of getOptionsForDisplay(); track $index) {
                <option [value]="getOptionText(option)">
                  {{ getOptionText(option) }}
                </option>
              }
            </select>
          }

          @if (selectedOptionIndex !== null && options[selectedOptionIndex]?.isCustomOption) {
            <div class="custom-option-wrapper">
              <input
                type="text"
                class="custom-option-input"
                [value]="options[selectedOptionIndex]?.customValue ?? ''"
                (input)="onCustomValueChange(selectedOptionIndex!, $any($event.target).value)"
                [disabled]="disabled()"
                placeholder="Enter your custom value...">
            </div>
          }
        }

        <!-- Show dynamic options placeholder only when no options are populated -->
        @if (!hasPopulatedOptions() && question().hasDynamicOptions) {
          <div class="dynamic-dropdown-preview">
            <span class="dropdown-placeholder">Select an option</span>
            <i class="pi pi-chevron-down dropdown-arrow"></i>
          </div>
          <div class="dynamic-config-summary">
            <span class="material-symbols-outlined config-icon">dynamic_feed</span>
            <span class="config-text">Dynamic options configured</span>
          </div>
        }

        <!-- No options message for static dropdowns without options -->
        @if (!hasPopulatedOptions() && !question().hasDynamicOptions) {
          <p class="no-options-message">No options available</p>
        }

        @if (question().helperText) {
          <span class="helper-text">{{ question().helperText }}</span>
        }
      </div>
    </div>
  }
</div>

